import styled from 'styled-components'  



export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    height: 200px;
    background: var(--darkGrey);
    padding : 0 20px;

`;

export const Content = styled.div`
    position:relative;
    max-width: var(--maxWidth);
    width : 100%;
    height: 55px;
    background: var(--medGrey);
    margin : 0 auto;
    border-radius:40px;
    color:var(--white);

    img{
        position:absolute;
        left:15px;
        top:14px;
        width:30px;
    }
    input {
        position:absolute;
        left:0;
        margin: 12px 0;
        padding : 0 0 0 60px;
        border : 0;
        width: 95%;
        background:transparent;
        heigth:40px;
        color:var(--white);
        font-size:var(--fontBig);

        :focus{
            outline:none;
        }
    }

`;